// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes } from 'react-router-dom';
import routes from './routes'; 
import './styles/styles.scss';
interface RoutesProps {
  appRoutes: Array<any>;
}
const App = ({ appRoutes }: RoutesProps) => {
  return (
    <Router>
      <Routes>{routes({ appRoutes })}</Routes>
    </Router>
  );
};

export default App;
